import React from 'react';

const CheckBorderIcon = (props) => (
  <svg width="46" height="46" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <rect stroke="#0ECF95" stroke-width="2" x="1" y="1" width="44" height="44" rx="22"/>
      <path d="m35.636 16.257.115.11.065.08c.302.369.23 1.006-.204 1.356l-17.36 13.962c-.36.29-.892.314-1.287.059a1.23 1.23 0 0 1-.34-.276l-6.395-7.77-.088-.121c-.235-.352-.178-.893.167-1.23l.12-.105c.41-.327 1.108-.257 1.475.189l5.788 7.035 16.551-13.312c.363-.291.892-.309 1.278-.063l.115.086z" fill="#0ECF95"/>
    </g>
  </svg>
);

export default CheckBorderIcon;
